// Copyright (c) 2026 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useState } from 'react';

export const useDisputeSettlementObligationForm = () => {
  const [reason, setReason] = useState('');

  return {
    reason,
    setReason,
  };
};
